import useStore from "stores/index";
import { ClassroomDetails } from "stores/classroomStore_I";

function checkIsInSession(expiry: number) {
	if (expiry > Date.now() / 1000) {
		return true;
	}
	return false;
}

export function checkForActiveMonitoringSession(): ClassroomDetails | undefined {
	const classrooms = useStore.getState().classroom.getClassrooms();
	// There should only be one other active monitoring classroom, if not then there is bug.
	return classrooms.find(
		(c: ClassroomDetails) => c.session?.isMonitoring && c.session?.sessionEndTime && checkIsInSession(c.session?.sessionEndTime)
	);
}
